import { render, staticRenderFns } from "./_optionalQuestion.vue?vue&type=template&id=e9dcddea"
import script from "./_optionalQuestion.vue?vue&type=script&lang=js"
export * from "./_optionalQuestion.vue?vue&type=script&lang=js"
import style0 from "./_optionalQuestion.vue?vue&type=style&index=0&id=e9dcddea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports